/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type RewardsMessageProvider_tradeFirm$ref = any;
export type TradeRewardsMessagingWrapper_user$ref = any;
export type TradeRewardsMessagingWrapper_user = {
    readonly serviceId: string | null;
    readonly tradeFirm?: {
        readonly " $fragmentRefs": RewardsMessageProvider_tradeFirm$ref;
    } | null;
    readonly " $refType": TradeRewardsMessagingWrapper_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "TradeRewardsMessagingWrapper_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "tradeFirm",
          "storageKey": null,
          "args": null,
          "concreteType": "TradeFirmType",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "RewardsMessageProvider_tradeFirm",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'c29a706e72758728c590a8b824aa5308';
export default node;
